import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function TableBody({ children }: Props) {
  return <div role="rowgroup">{children}</div>;
}
